import { render } from "./App.vue?vue&type=template&id=71ad009f"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=71ad009f&lang=css"

import exportComponent from "C:\\Users\\linco\\Desktop\\RKD\\VoidgeWeb3Template\\voidge-web3-template\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__